import React from 'react';
import Icon from '../../../components/AppIcon';

export default function PaymentSection({ 
  paymentStatus, 
  onPaymentStatusChange, 
  setPaymentStatus,
  paidAmount, 
  onPaidAmountChange,
  setPaidAmount,
  paymentMethod, 
  onPaymentMethodChange,
  setPaymentMethod,
  paymentNotes, 
  onPaymentNotesChange,
  setPaymentNotes,
  totalAmount 
}) {
  const handleStatusChangeFn = onPaymentStatusChange || setPaymentStatus;
  const handlePaidAmountChangeFn = onPaidAmountChange || setPaidAmount;
  const handlePaymentMethodChangeFn = onPaymentMethodChange || setPaymentMethod;
  const handlePaymentNotesFn = onPaymentNotesChange || setPaymentNotes;

  // Auto-adjust paid amount based on status selection
  const handleStatusChange = (e) => {
    const status = e?.target?.value;
    if (typeof handleStatusChangeFn === 'function') handleStatusChangeFn(status);
    
    // Auto-fill paid amount based on status
    if (status === 'non_paye') {
      if (typeof handlePaidAmountChangeFn === 'function') handlePaidAmountChangeFn(0);
    } else if (status === 'paye' && totalAmount > 0) {
      if (typeof handlePaidAmountChangeFn === 'function') handlePaidAmountChangeFn(totalAmount);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center">
          <Icon name="CreditCard" size={24} className="text-emerald-600" />
        </div>
        <h2 className="text-lg font-semibold text-gray-900">Paiement</h2>
      </div>

      <div className="space-y-4">
        {/* Payment Status Select */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Statut du paiement
          </label>
          <select
            value={paymentStatus}
            onChange={handleStatusChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
          >
            <option value="non_paye">Non payé</option>
            <option value="partiel">Acompte / Partiel</option>
            <option value="paye">Payé intégralement</option>
          </select>
          <p className="mt-1 text-xs text-gray-500">
            Sélectionnez le statut de paiement pour cet envoi
          </p>
        </div>

        {/* Paid Amount Input */}
        {(paymentStatus === 'partiel' || paymentStatus === 'paye') && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Montant déjà payé (€)
            </label>
            <input
              type="number"
              min="0"
              step="1"
              value={paidAmount || 0}
              onChange={(e) => typeof handlePaidAmountChangeFn === 'function' && handlePaidAmountChangeFn(Number(e?.target?.value))}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
              placeholder="0.00"
            />
            {totalAmount > 0 && (
              <p className="mt-1 text-xs text-gray-500">
                Total à payer : {totalAmount?.toFixed(2)} €
              </p>
            )}
          </div>
        )}

        {/* Payment Method (Optional) */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Mode de paiement (optionnel)
          </label>
          <input
            type="text"
            value={paymentMethod || ''}
            onChange={(e) => typeof handlePaymentMethodChangeFn === 'function' && handlePaymentMethodChangeFn(e?.target?.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
            placeholder="Espèces, Virement, Carte, etc."
          />
        </div>

        {/* Payment Notes (Optional) */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Notes de paiement (optionnel)
          </label>
          <textarea
            value={paymentNotes || ''}
            onChange={(e) => typeof handlePaymentNotesFn === 'function' && handlePaymentNotesFn(e?.target?.value)}
            rows={3}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent resize-none"
            placeholder="Informations complémentaires sur le paiement..."
          />
        </div>

        {/* Payment Summary */}
        {totalAmount > 0 && (
          <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4">
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Total à payer:</span>
                <span className="font-semibold text-gray-900">{totalAmount?.toFixed(2)} €</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Montant payé:</span>
                <span className="font-semibold text-emerald-600">{(paidAmount || 0)?.toFixed(2)} €</span>
              </div>
              <div className="flex justify-between pt-2 border-t border-emerald-200">
                <span className="text-gray-600 font-medium">Reste à payer:</span>
                <span className="font-bold text-gray-900">
                  {Math.max(totalAmount - (paidAmount || 0), 0)?.toFixed(2)} €
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}